import { MemberStatusEnum } from 'src/shared/models/enums/memberStatusEnum';
import { MemberStatusTabKeysEnum } from 'src/shared/models/enums/memberStatusTabKeys.enum';

export interface MemberTabItem {
  label: string;
  key: string;
  values: number[];
  description: string;
  hiddenForOtherContactMode: boolean;
}

export const memberTabs: MemberTabItem[] = [
  {
    label: 'member:tabs.active',
    key: MemberStatusTabKeysEnum.Active,
    values: [MemberStatusEnum.Paid, MemberStatusEnum.NotPaid],
    description: 'member:tabs.activeDescription',
    hiddenForOtherContactMode: false,
  },
  {
    label: 'member:tabs.paid',
    key: MemberStatusTabKeysEnum.Paid,
    values: [MemberStatusEnum.Paid],
    description: 'member:tabs.paidDescription',
    hiddenForOtherContactMode: false,
  },
  {
    label: 'member:tabs.notPaid',
    key: MemberStatusTabKeysEnum.NotPaid,
    values: [MemberStatusEnum.NotPaid],
    description: 'member:tabs.notPaidDescription',
    hiddenForOtherContactMode: false,
  },
  {
    label: 'member:tabs.newMember',
    key: MemberStatusTabKeysEnum.NewMember,
    values: [MemberStatusEnum.NewMember],
    description: 'member:tabs.newMemberDescription',
    hiddenForOtherContactMode: true,
  },
  {
    label: 'member:tabs.notMember',
    key: MemberStatusTabKeysEnum.NotMember,
    values: [MemberStatusEnum.NotMember],
    description: 'member:tabs.notMemberDescription',
    hiddenForOtherContactMode: false,
  },
];
